import getRegionPrefixForTitle from './getRegionPrefixForTitle';
import getProductPrefixForTitle from './getProductPrefixForTitle';

const getPrefixForTitle = (
  regionIds: string[],
  productIds: string[],
  isShowAbs: boolean = false,
): string => {
  const regionPrefix = getRegionPrefixForTitle(regionIds);
  const productPrefix = getProductPrefixForTitle(productIds, isShowAbs);

  return regionPrefix + productPrefix;
};

export default getPrefixForTitle;
